angular.module("resume_reports")

    .controller("ResumeReportsCtrl", ['$scope', '$rootScope', '$controller', '$state', 'Restangular', '$uibModal', 'modalService', '$filter','gridService','$q','treeService', 'logService',
        function ($scope, $rootScope, $controller, $state, Restangular, $uibModal, modalService, $filter, gridService, $q, treeService, logService) {

            $rootScope.title = $filter('translate')('resume_report.title');

            $scope.resume_report = {
                person: {},
                event: {}           

            };
            $scope.showResumeReport = false;

            Restangular.all('Persons/AllPersons').getList().then(function (persons) {
                $scope.selectPersons = persons;
                $scope.selectPersons.unshift({
                    id: null,
                    name: $filter('translate')('resume_report.all')
                });
                $scope.resume_report.person = $scope.selectPersons[0];
            });

            /*Restangular.all('Events').getList({ is_template: false }).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('resume_report.all')
                });
                $scope.resume_report.event = $scope.selectEvents[0];
            });*/
            var options = {
                searchName: "",
                is_template: false
            };
            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('resume_report.all')
                });
                $scope.resume_report.event = $scope.selectEvents[0];
            });

            $rootScope.$on('rowExpandedStateChanged', function (e) {
                logService.debug("aaa", e);
            });
          

            $scope.generateReport = function () {

                $scope.showResumeReport = true;

                if (angular.isDefined($scope.gridOptionsResume)) {
                    $scope.gridOptionsResume.loadData(false);
                } else {
                    $scope.gridOptionsResume = {
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        enableHiding: false,
                        gridMenuShowHideColumns: true,
                        showTreeExpandNoChildren: false,
                        paginationPageSizes: [3, 10, 25],
                        paginationPageSize: 3,
                        onRegisterApi: function (gridApi) {                            
                            this.gridApi = gridApi;
                        },
                        pdfTitle: $filter('translate')('resume_reports.pdf_title'),
                        columnDefs: [
                            { name: 'event_name', field: 'event_name', displayName: $filter('translate')('events.resume.event'), enableGridMenu: false },
                            { name: 'name', width: 150, field: 'name', displayName: $filter('translate')('events.resume.name'), enableGridMenu: false },
                            { name: 'surname', width: 150, field: 'surname', displayName: $filter('translate')('events.resume.surname'), enableGridMenu: false },
                            { name: 'lastname', width: 150, field: 'lastname', displayName: $filter('translate')('events.resume.lastname'), enableGridMenu: false },
                            { name: 'dni', width: 100, field: 'dni', displayName: $filter('translate')('events.resumen.dni'), enableGridMenu: false },
                           // { name: 'total_time', field: 'seconds', displayName: $filter('translate')('event.resumen.total_time'), enableGridMenu: false },
                            /*{
                                name: 'infoMonitoring', width: 550, field: 'infoMonitoring',
                                displayName: $filter('translate')('events.resume.monitoring'), enableGridMenu: false,
                                cellTemplate: '<div ng-bind-html="row.entity.infoMonitoring | to_trusted"></div>'
                                , customFormatFn: function (value) {
                                    logService.debug(value.replace(/<br>/g, "\n"));
                                  if (value != null) {
                                      return value.replace(/<br>/g, "\n");
                                  }
                                  return "";
                              },
                            },*/
                                                   
                        ],
                        getData: function (options) {
                            logService.debug(options);
                            var deferred = $q.defer();
                            options.person_id = $scope.resume_report.person.id;
                            options.event_id = $scope.resume_report.event.id;

                            Restangular.all('Reports/Resume').getList(options).then(function (results) {
                                logService.debug(results);
                                var data = treeService.resume_report(results);

                                data.totalRows = results.totalRows;
                                logService.debug(data);
                                deferred.resolve(data);
                            }, function (response) {
                                alert(response.message);
                                deferred.reject(response);
                            });
                            return deferred.promise;
                            
                           // return Restangular.all('Reports/Resume').getList(options);
                        }

                    };
                }
            }

        }])

;